import { render, staticRenderFns } from "./sidebar-menu-global.vue?vue&type=template&id=f1f5d7ca&scoped=true"
import script from "./sidebar-menu-global.vue?vue&type=script&lang=js"
export * from "./sidebar-menu-global.vue?vue&type=script&lang=js"
import style0 from "./sidebar-menu-global.vue?vue&type=style&index=0&id=f1f5d7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5d7ca",
  null
  
)

export default component.exports